import { useMapEvents } from 'react-leaflet'
import { LeafletMouseEvent } from 'leaflet'

interface IMapClickHandlerProps {
  onMapClick: (e: LeafletMouseEvent) => void
}

export const MapClickHandler = ({ onMapClick }: IMapClickHandlerProps) => {
  useMapEvents({
    click: onMapClick
  })
  return null
}
